<template>
  <div class="home">
    <!-- 头部 -->
    <el-row>
      <el-col :span="24">
        <div class="header-left">
          <el-dropdown :hide-on-click="false">
            <span class="el-dropdown-link" style="font-size:18px;">
              {{ $route.meta.title }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="goDataboard">大数据智慧图书馆</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
        <div class="header-right">
          <div class="header-user-con">
            <!-- 用户头像 -->
            <div class="user-avator">
              <img :src="image" class="user-avator"/>
            </div>
            <!-- 用户名下拉菜单 -->
            <el-dropdown
                class="user-name"
                trigger="click"
                @command="handleCommand"
            >
              <span class="el-dropdown-link">
                {{ username }}
                <i class="el-icon-caret-bottom"></i>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item divided command="loginout"
                  >退出登录
                  </el-dropdown-item
                  >
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 中间 -->
    <el-row class="menu">
      <el-col :span="14" class="menu-content">
        <div class="menu-list">
          <div
              class="menu-item"
              v-for="(item, index) in menuList"
              :key="index"
              @click="goHome(item.index)"
          >
            <div :style="{ background: item.color }">
              <i :class="item.icon"></i>
              <span>{{ item.title }}</span>
            </div>
          </div>
          <!-- <a class="menu-item" v-for="(item, index) in menuList" :key="index" href="#/dashboard2">
            <div :style="{ background: item.color }">
              <i :class="item.icon"></i>
              <span>{{ item.title }}</span>
            </div>
          </a> -->
        </div>
      </el-col>
    </el-row>
<!--    <el-dialog-->
<!--        title="提示"-->
<!--        v-model="dialogVisible"-->
<!--        width="20%"-->
<!--        center>-->
<!--      <div style="margin: auto;text-align: center !important;">-->
<!--        <el-form ref="register">-->
<!--          <el-form-item prop="StrUserName">-->
<!--            <el-input v-model="param.StrPassword" placeholder="请输入用户名"/>-->
<!--          </el-form-item>-->
<!--          <el-form-item prop="StrPassword">-->
<!--            <el-input placeholder="请输入密码" v-model="param.StrPassword" @keyup.enter="login()"-->
<!--                      type="password"/>-->
<!--          </el-form-item>-->
<!--          <el-button type="primary" size="mini" @click="btnAddorMod">确定</el-button>-->
<!--        </el-form>-->
<!--      </div>-->
<!--      </el-dialog>-->
    <change-password></change-password>
  </div>
</template>
<script>
import changePassword from "@/components/changePassword";
import {DATABOARD_URL} from "@/utils/constants";
import {logout} from "@/utils/auth";
import {buildMenus} from "@/utils/menu";
export default {
  components:{
    changePassword
  },
  data() {
    return {
      username: localStorage.getItem("username"),
      image: localStorage.getItem("schoolimg"),
      menuList: [],
      route: [],

    };
  },
  methods: {
    goDataboard() {
      // this.$router.push('/homestatiscs')
      // window.location.href = 'http://databoard.sanyue100.com/'
      window.location.href = DATABOARD_URL
    },
    // 用户名下拉菜单选择事件
    handleCommand(command) {
      if (command == "loginout") {
        // 通知后端吊销 access/refresh 令牌,再清理本地会话
        logout().finally(() => {
          this.$router.push("/login");
        });
      }
    },
    getroute() {
      // 菜单组装(权限过滤/IntSort 排序/固定项)统一在 utils/menu,侧边栏与首页卡片共用。
      // 本页是区域级以上落地页,groups 即中间的功能卡片分组。
      const {groups} = buildMenus(localStorage.getItem("route"));
      this.route = groups;
    },
    getMenuList() {
      var colorArr = [
        "#8DC153",
        "#EC87C1",
        "#37BD9C",
        "#3BAEDA",
        "#F98852",
        "#FB6E52",
        "#E6A23C",
        "#F56C6C",
        "#67C23A",
      ];
      for (let i = 0; i < this.route.length; i++) {
        // 空分组(组内没有任何前端可识别的已授权子菜单)直接跳过,
        // 否则取 subs[0].index 会抛错导致整个首页白屏。
        if (!this.route[i].subs || !this.route[i].subs[0]) continue;
        let menu = {
          title: this.route[i].title.substring(0, 2),
          icon: this.route[i].icon,
          color: colorArr[i],
          //这个要为他的第一个subs
          index: this.route[i].subs[0].index,
        };
        this.menuList.push(menu);
      }
    },
    goHome(index) {
      switch (index) {
        case '/bookfile':
          index = 'bookManagement' + index;
          break;
        case '/journalsubscribe':
          index = 'journal' + index;
          break;
        case '/readerlendranking':
          index = 'charts' + index;
          break;
        case '/circulation':
          index = 'allcirculation' + index;
          break;
        case '/readerfile':
          index = 'reader' + index;
          break;
        case '/readerimport':
          index = '7' + index;
          break;
        case '/school':
          index = 'donate' + index;
          break;
      }
      //将路径存放到localStorage中
      localStorage.setItem("active", index);
      this.$router.push(index);
    },
  },
  created() {
    this.getroute();
    this.getMenuList();
  },
};
</script>
<style scoped>
.home {
  height: 100%;
  background: url("../assets/img/home-bg.jpg") no-repeat;
  background-size: 100% 100%;
}

.el-row:first-child {
  padding: 20px 15px;
}

.header-left {
  float: left;
  height: 50px;
  line-height: 50px;
  font-size: 30px;
  color: #fff;
}

.header-right {
  float: right;

}

.header-user-con {
  display: flex;
  height: 50px;
  align-items: center;
}

.user-avator {
  margin-right: 5px;
}

.user-avator img {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
}

.el-dropdown-link {
  cursor: pointer;
  color: #fff;
}

.menu {
  height: 100%;
}

.menu-content {
  margin: 100px auto;
  height: 100%;
}

.menu-list {
  height: 60%;
  background: hsla(0, 19%, 92%, 0.7);
}

.menu-item {
  float: left;
  margin: 50px 0 0 40px;
  cursor: pointer;
  color: #fff;
  font-size: 20px;
  text-align: center;
  /* transition: all 1s linear 0s; */
}

.menu-item div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 120px;
  height: 150px;
  margin: 5px auto;
  border-radius: 6px;
}

.menu-item div:hover {
  transform: scale(1.1, 1.1);
}

.menu-item i {
  padding-bottom: 20px;
}

</style>
